import { useCallback } from "react";
import { PermissionsEnums } from "../api/types/authorisation/enums/PermissionsEnums";
import { RootState } from "../store";
import { useSelector } from "react-redux";

export function usePermissionCheck() {
  const user = useSelector((state: RootState) => state.authorisation?.user);

  const checkPermission = useCallback(
    (
      permissions?: PermissionsEnums | PermissionsEnums[],
      requireAll: boolean = false,
    ) => {
      if (!permissions) return true;

      const userPermissions = user?.permissions?.map((p) => p.name) || [];

      if (Array.isArray(permissions)) {
        return requireAll
          ? permissions.every((perm) => userPermissions.includes(perm))
          : permissions.some((perm) => userPermissions.includes(perm));
      }

      return userPermissions.includes(permissions);
    },
    [user?.permissions],
  );

  return { checkPermission };
}
